import { useConnectivityStore } from '@/stores/connectivityStore';

// While offline, almost every page navigation needs fresh data from Firestore
// or Algolia, which isn't available — so a client-side navigation to a detail
// page (e.g. clicking a property from the index) would resolve to no data and
// throw a 404. Instead of letting that happen, block the navigation and pulse
// the offline toast so the user stays on the current page until reconnected.
export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) return;

  const connectivityStore = useConnectivityStore();
  if (connectivityStore.isOnline) return;

  // Allow the initial render / hydration and same-page (hash) changes.
  if (!from || to.path === from.path) return;

  connectivityStore.notifyBlocked();
  return abortNavigation();
});
